module.exports = __webpack_public_path__ + "static/img/ipad-pickup-recruit.ab0a2fc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/ipad-pickup-recruit.png
// module id = rFkc
// module chunks = 1